import { useLocation } from "react-router";

export function PageContainer({ children }: { children: React.ReactNode }) {
  const isLanding = useLocation().pathname === "/";

  return <main className={isLanding ? "flex-1" : "flex-1 pb-28 pt-4"}>{children}</main>;
}
